export const DB_NAME = "ICPSwap-app";
export const DB_VERSION = 11;
